import { api, withReducer } from './services';
import { PLATFORMS } from './constants';
import { executeScripts, getPortalVariable } from './utils';
import {
  GET_BASKET_COUNT_SUCCESS,
  getBasketCountAction,
} from './actions/BasketCountAction';
import { GET_MENU_SUCCESS, getMenuAction } from './actions/MenuAction';
import {
  GET_PROMOS_SUCCESS,
  GET_PROMOS_FAILURE,
  getPromosAction,
} from './actions/PromosAction';

export const initialState = {
  isB2B: false,
  isAuthenticated: false,
  hasProductsBeenFetched: false,
  hasPromosBeenFetched: false,
  platform: PLATFORMS.FRANCE,
  basketCount: 0,
  products: [],
  promos: [],
};

const loadInitialState = () => {
  const registerModal = getPortalVariable('registerModal');
  const registerSearchbar = getPortalVariable('registerSearchbar');

  executeScripts(registerModal, registerSearchbar);
};

export const actions = {
  loadInitialState,
  getBasketCount: baseUrl => dispatch =>
    api(dispatch, getBasketCountAction(baseUrl)),
  getMenu: (platformId, useCache) => dispatch =>
    api(dispatch, getMenuAction(platformId, useCache)),
  getPromos: (baseUrl, platformId, isB2B, userId, isNewUser) => dispatch =>
    api(
      dispatch,
      getPromosAction(baseUrl, platformId, isB2B, userId, isNewUser),
    ),
};

export const actionHandlers = {
  [GET_PROMOS_SUCCESS]: (state, action) => {
    const { promos } = action.payload;

    return {
      ...state,
      promos: promos.content,
      hasPromosBeenFetched: true,
    };
  },
  [GET_PROMOS_FAILURE]: state => {
    return {
      ...state,
      promos: [],
      hasPromosBeenFetched: true,
    };
  },
  [GET_MENU_SUCCESS]: (state, action) => {
    const { products } = action.payload;

    return {
      ...state,
      products: products.content,
      hasProductsBeenFetched: true,
    };
  },
  [GET_BASKET_COUNT_SUCCESS]: (state, action) => {
    const { basketCount } = action.payload;

    return {
      ...state,
      basketCount,
    };
  },
};

export const reducer = withReducer(initialState, actionHandlers);
